import { render, staticRenderFns } from "./StudentFilter.vue?vue&type=template&id=10d2e476&scoped=true"
import script from "./StudentFilter.vue?vue&type=script&lang=js"
export * from "./StudentFilter.vue?vue&type=script&lang=js"
import style0 from "./StudentFilter.vue?vue&type=style&index=0&id=10d2e476&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d2e476",
  null
  
)

export default component.exports